<template>
  <OrdenesFacturacion endpoint="/ordenOrdEntregadas"></OrdenesFacturacion>
</template>

<script>
import { defineComponent } from 'vue'

import OrdenesFacturacion from '../components/OrdenesFacturacion.vue'

export default defineComponent({
  name: 'OrdenesFacturacionView',

  components: {
    OrdenesFacturacion
  }
})
</script>
